import React, { useState, useEffect } from "react";
import axios from "axios";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import PaginatedSortableTable from "../components/PaginatedSortableTable";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { GetAdjustmentByType, GetAdjustment } from "../components/Adjust";
dayjs.extend(utc);
dayjs.extend(timezone);

export default function UserInfo() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const user = state?.user;
  const [userData, setUserData] = useState(null);
  const [totalLogs, setToTalLogs] = useState(null);
  const [vendors, setVendors] = useState(null);
  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState(currentYear.toString());
  const [selectedMonth, setSelectedMonth] = useState("01");

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const TIMEZONE = "Asia/Seoul";
  const formatDate = (date) => date.toISOString().split("T")[0]; // ✅ 1. formatDate 먼저 선언
  const today = new Date(); // ✅ 2. 그다음 today
  const yesterday = new Date(today); // ✅ 3. 그다음 yesterday
  yesterday.setDate(yesterday.getDate() - 1);
  const [startDate, setStartDate] = useState(formatDate(today));
  const [endDate, setEndDate] = useState(formatDate(today));
  const { setIsLoggedIn } = useOutletContext();

  const handleDateChange = (year, month) => {
    const start = `${year}-${month}-01`;
    const end = new Date(parseInt(year), parseInt(month), 0)
      .toISOString()
      .slice(0, 10);
    setStartDate(start);
    setEndDate(end);
  };

  const onYearChange = (e) => {
    const year = e.target.value;
    setSelectedYear(year);
    handleDateChange(year, selectedMonth);
  };

  const onMonthChange = (e) => {
    const month = e.target.value;
    setSelectedMonth(month);
    handleDateChange(selectedYear, month);
  };

  const handleDateRange = (type) => {
    const today = new Date();
    let start, end;

    switch (type) {
      case "today":
        start = end = formatDate(today);
        break;
      case "yesterday":
        const y = new Date();
        y.setDate(today.getDate() - 1);
        start = end = formatDate(y);
        break;
      case "week":
        const w = new Date();
        w.setDate(today.getDate() - 6); // 최근 7일
        start = formatDate(w);
        end = formatDate(today);
        break;
      default:
        return;
    }

    setStartDate(start);
    setEndDate(end);
  };

  const badgeClass =
    user?.agentLevel === "0" ? "super" : `M${user?.agentLevel || ""}`;
  const agentPath = [user?.agents, user?.agent]
    .filter(Boolean)
    .join(",")
    .split(",");
  const mydata = JSON.parse(localStorage.getItem("first"));
  const myLevel = parseInt(mydata?.auth_level || "0");
  const params = {
    userId: user?.userId,
    processed_at_start: startDate,
    processed_at_end: endDate,
  };

  const getVendors = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/Vendors`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setVendors(res.data.vendor_list);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  const fetchTotalTransaction = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${API_BASE}/api/TotalTransaction`, {
        params,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setToTalLogs(res.data.rows);
      setUserData(res.data.adjust);
    } catch (err) {
      if (axios.isAxiosError(err) && err.response) {
        if (
          err.response.status === 401 ||
          err.response.status === 403 ||
          err.response.status === 500
        ) {
          localStorage.removeItem("token");
          setIsLoggedIn(false); // 로그인 상태 false 처리
          navigate("/login"); // 로그인 화면으로 리다이렉트
          return;
        }
      }
      console.error("조회 실패:", err);
    }
  };

  useEffect(() => {
    if (!user) return;
    fetchTotalTransaction();
    getVendors();
  }, [user]);

  const sortOptions = [
    { value: "createdAt:asc", label: "처리시간 - 오름차순" },
    { value: "createdAt:desc", label: "처리시간 - 내림차순" },
  ];

  const renderRow = (log, index) => {
    if (!totalLogs || totalLogs.length === 0) {
      return (
        <tr>
          <td colSpan="12" className="text-center">
            데이터가 없습니다.
          </td>
        </tr>
      );
    }
    const formatted = dayjs(log.createdAt)
      .tz(TIMEZONE)
      .format("YYYY-MM-DD (HH:mm:ss [UTC +9])");

    return (
      <tr key={index}>
        <td
          className="text-center"
          data-org-colspan="1"
          data-priority="1"
          data-columns="idcf05ad7c57ee78-col-0"
          data-pos-x="0"
          colSpan="1"
          style={{ display: "table-cell" }}
        >
          <button className="btn btn-primary btn-sm btn-xsm">
            <em className="icon ni ni-link"></em>
          </button>
        </td>

        
        <td
          className="text-start table-active"
          colSpan="1"
          data-columns="id177420d488f01-col-2"
          data-org-colspan="1"
          data-pos-x="2"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span>
            {agentPath.map((agentId, i) => {
              const reversedIndex = agentPath.length - i - 1;
              const level = parseInt(user?.agentLevel || "0") - reversedIndex;
              if (level < myLevel) return null;
              const badgeClass = level === 0 ? "super" : `M${level}`;
              return (
                <em
                  key={i}
                  className={`badge me-1 ${badgeClass}`}
                  style={{ cursor: "pointer" }}
                >
                  {agentId}
                </em>
              );
            })}
          </span>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="id177420d488f01-col-3"
          data-org-colspan="1"
          data-pos-x="3"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="user-name">
            <span className="badge rounded-pill badge-dim bg-outline-info me-1">
              지갑
            </span>
            <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
              S
            </em>
          </div>
          <div className="user-toggle">
            <a className="dropdown-toggle" data-bs-toggle="dropdown" href="#">
              <div className="user-toggle">
                <div className="user-info">
                  <div className="user-name dropdown-indicator">
                    <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                      아이디
                    </span>{" "}
                    {user?.userId}
                  </div>
                  <div className="user-status">
                    <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                      사이트아이디
                    </span>
                    {user?.siteId}
                  </div>
                </div>
              </div>
            </a>
            <div className="dropdown-menu dropdown-menu-start">
              <ul className="link-list-opt">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigator.clipboard
                        .writeText(user?.userId)
                        .then(() => {})
                        .catch((err) => {
                          console.error("복사 실패:", err);
                        });
                    }}
                  >
                    <em className="icon far fa-copy" />
                    <span>아이디 복사</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </td>
        <td
          className=""
          colSpan="1"
          data-columns="id177420d488f01-col-4"
          data-org-colspan="1"
          data-pos-x="4"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <ul className="bet-log-tb game-type">
            <li>
              <span className="badge rounded-pill badge-dim bg-outline-primary">
                {` ${log.gameType} > ${log.vendor} `}
              </span>
            </li>
            <li>
              <span className="gamename">
                <b>{log.gameId}</b>
              </span>
            </li>
            <li className="code">Code : {log.refId}</li>
          </ul>
        </td>
        <td
          className="text-center fw-bold"
          colSpan="1"
          data-columns="id177420d488f01-col-5"
          data-org-colspan="1"
          data-pos-x="5"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span
            className={`badge rounded-pill bg-${
              log.type === "bet" ? "azure" : "teal"
            }`}
          >
            {log.type === "bet" ? "베팅" : "승"}
          </span>
          <br />{" "}
        </td>
        <td
          className="text-center text-center"
          colSpan="1"
          data-columns="id177420d488f01-col-6"
          data-org-colspan="1"
          data-pos-x="6"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          KRW
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id177420d488f01-col-7"
          data-org-colspan="1"
          data-pos-x="7"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span>
            {(parseInt(log.balance) - parseInt(log.amount)).toLocaleString()}
          </span>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id177420d488f01-col-8"
          data-org-colspan="1"
          data-pos-x="8"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <ul>
            <li>
              <span className={parseInt(log.amount) < 0 ? "paid" : "pback"}>
                <em
                  className={
                    parseInt(log.amount) < 0
                      ? "icon ni ni-minus-round-fill"
                      : "icon ni ni-plus-round-fill"
                  }
                ></em>
                <span>{Math.abs(parseInt(log.amount)).toLocaleString()}</span>
              </span>
            </li>
          </ul>
        </td>
        <td
          className="text-end"
          colSpan="1"
          data-columns="id177420d488f01-col-9"
          data-org-colspan="1"
          data-pos-x="9"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <div className="text-azure fw-bold">
            <span>{parseInt(log.balance).toLocaleString()}</span>
          </div>
        </td>
        <td
          className="text-center"
          colSpan="1"
          data-columns="id177420d488f01-col-10"
          data-org-colspan="1"
          data-pos-x="10"
          data-priority="1"
          style={{
            display: "table-cell",
          }}
        >
          <span style={{ fontSize: "95%" }}>
            {dayjs(log.createdAt).tz("Asia/Seoul").format("YYYY-MM-DD")}
            <font className="dateInHour">
              {" "}
              (
              {dayjs(log.createdAt)
                .tz("Asia/Seoul")
                .format("HH:mm:ss [UTC +9]")}
              )
            </font>
          </span>
        </td>
      </tr>
    );
  };

  //api_log 가져오기 (날짜별, 밴더별, 게임별, 베팅당첨금별=이거 지울까?)

  if (!userData) return <div>로딩 중...</div>;

  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block-lg vUserDetail">
              <div className="card card-bordered card-stretch">
                <div className="card-inner user-view-box">
                  <div className="row g-gs">
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="nk-block-head-content">
                        <div className="btn-group nav nav-tabs" role="tablist">
                          <button
                            className="btn btn-dim btn-outline-primary active"
                            data-bs-toggle="tab"
                            href="#tb_transaction"
                            id="trxs"
                            type="button"
                          >
                            <em className="icon ni ni-tranx d-none d-sm-inline-flex" />
                            전체거래
                          </button>
                          <button
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_bet"
                            id="bet"
                            type="button"
                          >
                            <em className="icon ni ni-tranx d-none d-sm-inline-flex" />{" "}
                            베팅내역
                          </button>
                          <button
                            aria-selected="false"
                            className="btn btn-dim btn-outline-primary"
                            data-bs-toggle="tab"
                            href="#tb_report"
                            id="report"
                            role="tab"
                            tabIndex="-1"
                            type="button"
                          >
                            <em className="icon ni ni-reports d-none d-sm-inline-flex" />{" "}
                            보고서
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-4 col-xxl-5">
                      <div className="nk-block-head nk-block-head-sm text-end">
                        <div className="nk-block-head-content">
                          <h3 className="nk-block-title page-title">
                            {user?.userId}
                            <strong className="text-primary small ms-2">
                              <em className="icon ni ni-coins d-none d-sm-inline-flex" />
                              <span>0</span>
                            </strong>
                          </h3>
                          <div className="nk-block-des text-soft">
                            <ul className="list-inline">
                              <li>
                                <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                  S
                                </em>
                              </li>
                              <li>
                                {" "}
                                #NO.{" "}
                                <span className="text-base">{user?.idx}</span>
                              </li>
                              <li>
                                사이트아이디 :{" "}
                                <span className="text-base">
                                  {user?.siteId}{" "}
                                </span>
                              </li>
                              <li>
                                <span>
                                  <em
                                    className={`badge me-1 ${badgeClass}`}
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    {user?.agent}
                                  </em>
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="-accordion" id="accordion-dboard">
              <div
                className="accordion-body mt-4 collapse show"
                id="accordion-item-ik"
              >
                <div className="nk-block">
                  <div className="row g-gs">
                    <div
                      className="col-sm-12 col-lg-6 col-xxl-3"
                      usertype="user"
                    >
                      <div className="card card-bordered h-100">
                        <div className="card-inner h-100 stretch flex-column">
                          <div className="team">
                            <table className="table table-small-font table-tighten table-bordered">
                              <thead>
                                <tr>
                                  <th className="text-center">트리정보</th>
                                  <th className="text-center">정보</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td className="text-center vam px-2">
                                    <span>
                                      {agentPath.map((agentId, i) => {
                                        const reversedIndex =
                                          agentPath.length - i - 1;
                                        const level =
                                          parseInt(user?.agentLevel || "0") -
                                          reversedIndex;
                                        if (level < myLevel) return null;
                                        const badgeClass =
                                          level === 0 ? "super" : `M${level}`;
                                        return (
                                          <em
                                            key={i}
                                            className={`badge me-1 ${badgeClass}`}
                                            style={{ cursor: "pointer" }}
                                          >
                                            {agentId}
                                          </em>
                                        );
                                      })}
                                    </span>
                                  </td>
                                  <td className="text-center vam px-2">
                                    <h6 className="fs-6 mb-0">
                                      {user?.userId}
                                    </h6>
                                    <span className="sub-text">
                                      {user?.siteId}
                                    </span>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div className="user-card user-card-s2 table-responsive" />
                            <ul className="team-info">
                              <li className="text-center" />
                              <li>
                                <span>지갑 / Prefix</span>
                                <span>
                                  <em className="badge rounded-pill badge-dim bg-outline-info me-1 simm">
                                    S
                                  </em>{" "}
                                  / {user?.userId?.slice(0, 5)}
                                </span>
                              </li>
                              <li>
                                <span>통화 / 상태</span>
                                <span>
                                  KRW /{" "}
                                  <span className="badge rounded-pill badge-dim bg-outline-primary me-1">
                                    정상
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>가입일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  >
                                    {user?.created_at}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>수정일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  >
                                    {user?.created_at}
                                  </span>
                                </span>
                              </li>
                              <li>
                                <span>접속일</span>
                                <span>
                                  <span
                                    style={{
                                      fontSize: "95%",
                                    }}
                                  />
                                </span>
                              </li>
                              <li>
                                <div className="input-group">
                                  <textarea
                                    className="form-control"
                                    disabled
                                    style={{
                                      minHeight: "35px",
                                    }}
                                  />
                                </div>
                              </li>
                            </ul>
                            <div className="team-view">
                              <button
                                className="btn btn-sm btn-block btn-dim btn-primary"
                                type="button"
                              >
                                메모 수정
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane active" id="yday">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>{userData.yesterday_date} (어제)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.yesterday_adjust.bet}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.yesterday_adjust.win.toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.yesterday_adjust.tie.toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.yesterday_adjust.cancle.toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>
                                        {userData.yesterday_adjust.total_amt.toLocaleString()}
                                      </span>{" "}
                                      ({" "}
                                      {userData.yesterday_adjust.total_persent}{" "}
                                      % ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane active" id="overview">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>{userData.today_date}(오늘)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.today_adjust.bet.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.today_adjust.win.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.today_adjust.tie.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.today_adjust.cancle.toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>
                                        {userData.today_adjust.total_amt.toLocaleString()}
                                      </span>{" "}
                                      ( {userData.today_adjust.total_persent} %
                                      ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-12 col-lg-6 col-xxl-3">
                      <div className="card card-bordered card-full">
                        <div className="card-inner">
                          <div className="card-title-group mb-1">
                            <div className="card-title">
                              <h6 className="title">
                                <em className="icon ni ni-calendar-booking-fill" />{" "}
                                베팅내역
                              </h6>
                            </div>
                          </div>
                          <ul
                            className="nav nav-tabs nav-tabs-card nav-tabs-xs"
                            style={{
                              display: "none",
                            }}
                          >
                            <li className="nav-item">
                              <a
                                className="nav-link active"
                                data-bs-toggle="tab"
                                href="#overview"
                              >
                                오늘
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#yday"
                              >
                                어제
                              </a>
                            </li>
                            <li className="nav-item">
                              <a
                                className="nav-link"
                                data-bs-toggle="tab"
                                href="#thismonth"
                              >
                                이번달
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content mt-0">
                            <div className="tab-pane active" id="thismonth">
                              <div className="invest-ov gy-2">
                                <div className="subtitle">
                                  <b>{userData.month_date} (이번달)</b>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">베팅</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.month_adjust.bet.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">승</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.month_adjust.win.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">무</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>{userData.month_adjust.tie.toLocaleString()}</span>
                                    </div>
                                  </div>
                                </div>
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">취소</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount">
                                      <span>
                                        {userData.month_adjust.cancle.toLocaleString()}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="invest-ov gy-2">
                                <div className="invest-ov-details">
                                  <div className="invest-ov-stats">
                                    <div>
                                      <span className="amount">수익금</span>
                                    </div>
                                  </div>
                                  <div className="invest-ov-info text-end">
                                    <div className="amount link-primary">
                                      <span>
                                        {userData.month_adjust.total_amt.toLocaleString()}
                                      </span>{" "}
                                      ( {userData.month_adjust.total_persent} %
                                      ){" "}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="nk-block nk-block-lg pt-4">
              <div className="card card-bordered">
                <div className="tab-content">
                  <div className="tab-pane show active" id="tb_transaction">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div
                              className="nk-block nk-block-lg vTrxsAll"
                              id="opt-x"
                            >
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner p-3">
                                    <div className="nk-block nk-block-lg">
                                      <form className="mb-0">
                                        <div className="row tbSearch">
                                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-5">
                                            <div className="form-group">
                                              <div className="form-control-wrap raw">
                                                <div className="input-daterange input-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="sdate"
                                                      type="text"
                                                      value={startDate}
                                                      onChange={(e) =>
                                                        setStartDate(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className="input-group-addon">
                                                    ~
                                                  </div>
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="edate"
                                                      type="text"
                                                      value={endDate}
                                                      onChange={(e) =>
                                                        setStartDate(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                                            <div className="form-group">
                                              <div className="form-control-wrap radio-select-day">
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Yesterday"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange(
                                                        "yesterday"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Yesterday"
                                                  >
                                                    어제
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Today"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange("today")
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Today"
                                                  >
                                                    오늘
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Week"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange("week")
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Week"
                                                  >
                                                    일주일
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-3">
                                            <div className="form-control-wrap">
                                              <button
                                                className="btn btn-outline-primary btn-dim"
                                                type="submit"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  fetchTotalTransaction();
                                                }}
                                              >
                                                <em className="icon ni ni-search me-2" />{" "}
                                                검색
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>

                                  <div className="card-inner tableBox p-0">
                                    <div
                                      className="table-responsive"
                                      data-pattern="priority-columns"
                                    >
                                      <div>
                                        <table
                                          cellSpacing="0"
                                          className="table table-small-font table-tighten table-bordered table-striped"
                                        >
                                          <thead>
                                            <tr>
                                              <th className="text-center col-detail">
                                                상세
                                              </th>

                                              <th className="text-center">
                                                소속 에이전트
                                              </th>
                                              <th className="text-center">
                                                정보
                                              </th>
                                              <th className="text-center">
                                                게임정보
                                              </th>
                                              <th className="text-center">
                                                거래방식
                                              </th>
                                              <th className="text-center col-currency">
                                                화폐
                                              </th>
                                              <th className="text-center">
                                                이전
                                              </th>
                                              <th className="text-center">
                                                금액
                                              </th>
                                              <th className="text-center">
                                                이후
                                              </th>
                                              <th className="text-center">
                                                처리시간
                                              </th>
                                            </tr>
                                          </thead>

                                          {totalLogs && (
                                            <PaginatedSortableTable
                                              data={totalLogs}
                                              renderRow={renderRow}
                                              defaultSortField="createdAt"
                                              defaultSortOrder="desc"
                                              sortOptions={sortOptions}
                                            />
                                          )}
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_bet">
                    <div className="nk-block">
                      <div className="card">
                        <div className="card-inner-group">
                          <div className="card-inner">
                            <div
                              className="nk-block vLogsBettingCurrency"
                              id="opt-x"
                            >
                              <div className="card card-bordered">
                                <div className="card-inner-group">
                                  <div className="card-inner p-3">
                                    <div className="nk-block nk-block-lg">
                                      <form className="mb-0">
                                        <div className="row tbSearch">
                                          <div className="col-sm-12 col-md-12 col-lg-5 col-xl-6 col-xxl-5">
                                            <div className="form-group">
                                              <div className="form-control-wrap raw">
                                                <div className="input-daterange input-group">
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="sdate"
                                                      type="text"
                                                      value={startDate}
                                                      onChange={(e) =>
                                                        setStartDate(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                  <div className="input-group-addon">
                                                    ~
                                                  </div>
                                                  <div className="form-control-wrap">
                                                    <div className="form-icon form-icon-left">
                                                      <em className="icon ni ni-calendar" />
                                                    </div>
                                                    <input
                                                      className="form-control date-picker"
                                                      data-date-format="yyyy-mm-dd"
                                                      id="edate"
                                                      type="text"
                                                      value={endDate}
                                                      onChange={(e) =>
                                                        setStartDate(
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-5 col-xl-4 col-xxl-4">
                                            <div className="form-group">
                                              <div className="form-control-wrap radio-select-day">
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Yesterday"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange(
                                                        "yesterday"
                                                      )
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Yesterday"
                                                  >
                                                    어제
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Today"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange("today")
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Today"
                                                  >
                                                    오늘
                                                  </label>
                                                </div>
                                                <div className="custom-control custom-radio custom-control-pro no-control">
                                                  <input
                                                    className="custom-control-input"
                                                    id="alt-Week"
                                                    name="fv-sex"
                                                    type="radio"
                                                    onChange={() =>
                                                      handleDateRange("week")
                                                    }
                                                  />
                                                  <label
                                                    className="custom-control-label"
                                                    htmlFor="alt-Week"
                                                  >
                                                    일주일
                                                  </label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div className="col-sm-6 col-md-6 col-lg-2 col-xl-2 col-xxl-3">
                                            <div className="form-control-wrap">
                                              <button
                                                className="btn btn-outline-primary btn-dim"
                                                type="submit"
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  //베팅내역가져오는 api
                                                }}
                                              >
                                                <em className="icon ni ni-search me-2" />{" "}
                                                검색
                                              </button>
                                            </div>
                                          </div>
                                        </div>
                                      </form>
                                    </div>
                                  </div>

                                  <div className="card-inner tableBox p-0">
                                    <div
                                      className="table-wrapper"
                                      style={{
                                        borderTop: "1px dotted #BBB",
                                        paddingTop: "5px 0",
                                      }}
                                    >
                                      <div className="table-responsive">
                                        <div>
                                          <table
                                            cellSpacing="0"
                                            className="table table-small-font table-tighten table-bordered table-striped navbar-fixed-top"
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  className="text-center col-detail"
                                                  data-pos-x="0"
                                                  id="idf60eb3d4dde28-col-0"
                                                >
                                                  상세
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="1"
                                                  id="idf60eb3d4dde28-col-1"
                                                >
                                                  트리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="2"
                                                  id="idf60eb3d4dde28-col-2"
                                                >
                                                  정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="3"
                                                  id="idf60eb3d4dde28-col-3"
                                                >
                                                  게임
                                                </th>
                                                <th
                                                  className="text-center col-currency"
                                                  data-pos-x="4"
                                                  id="idf60eb3d4dde28-col-4"
                                                >
                                                  화폐
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="5"
                                                  id="idf60eb3d4dde28-col-5"
                                                >
                                                  베팅정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="6"
                                                  id="idf60eb3d4dde28-col-6"
                                                >
                                                  처리정보
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="7"
                                                  id="idf60eb3d4dde28-col-7"
                                                >
                                                  유저베팅
                                                </th>
                                                <th
                                                  className="text-center col-rsdata"
                                                  data-pos-x="8"
                                                  id="idf60eb3d4dde28-col-8"
                                                >
                                                  게임결과
                                                </th>
                                                <th
                                                  className="text-center"
                                                  data-pos-x="9"
                                                  id="idf60eb3d4dde28-col-9"
                                                >
                                                  처리시간
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              <tr>
                                                <td
                                                  className="text-center span-cell-emt spn-cell"
                                                  colSpan="14"
                                                >
                                                  <div className="nk-order-ovwg-ck text-red">
                                                    <h5>
                                                      조회된 정보가 없습니다.
                                                    </h5>
                                                  </div>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-inner p-3 cpaginationMongo">
                                    <div className="pnavi_wrap_flex">
                                      <div>
                                        <ul className="pagination justify-content-center justify-content-md-start">
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fas fa-angle-double-left" />
                                              <font className="d-lg-none d-xl-block">
                                                처음
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item">
                                            <a
                                              className="page-link disabled"
                                              href="#"
                                            >
                                              <i className="fa fa-angle-left" />
                                              <font className="d-lg-none d-xl-block">
                                                이전
                                              </font>
                                            </a>
                                          </li>
                                          <li className="page-item input">
                                            <input
                                              className="form-control text-center"
                                              type="number"
                                            />
                                          </li>
                                          <li className="page-item">
                                            <a className="page-link" href="#">
                                              <font className="d-lg-none d-xl-block">
                                                다음
                                              </font>
                                              <i className="fa fa-angle-right" />
                                            </a>
                                          </li>
                                        </ul>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="10">
                                            리스트 - 10
                                          </option>
                                          <option value="20">
                                            리스트 - 20
                                          </option>
                                          <option value="50">
                                            리스트 - 50
                                          </option>
                                          <option value="100">
                                            리스트 - 100
                                          </option>
                                        </select>
                                      </div>
                                      <div>
                                        <select className="form-select">
                                          <option value="-1">
                                            처리시간 - 내림차순
                                          </option>
                                          <option value="1">
                                            처리시간 - 오름차순
                                          </option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane" id="tb_report">
                    <ul className="nav nav-tabs nav-tabs-card">
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#tabintab02"
                        >
                          <span>
                            <i className="ni ni-calendar-alt-fill" />
                            정산 내역
                          </span>
                        </a>
                      </li>
                      <li className="nav-item d-none">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#tabintab03"
                        >
                          <span>
                            <i className="ni ni-calendar-booking-fill" />
                            월별 정산
                          </span>
                        </a>
                      </li>
                      <li className="nav-item d-none">
                        <a
                          className="nav-link"
                          data-bs-toggle="tab"
                          href="#tabintab04"
                        >
                          <span>활동로그</span>
                        </a>
                      </li>
                    </ul>
                    <div className="tab-content">
                      <div className="tab-pane active" id="tabintab02">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12" />
                                    <div className="col-12 col-md-5 col-xl-5 col-xxl-5 offset-xxl-2">
                                      <div className="form-group">
                                        <div className="form-control-wrap raw">
                                          <div className="input-daterange input-group">
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="sdate"
                                                type="text"
                                                value={startDate}
                                                onChange={(e) =>
                                                  setStartDate(e.target.value)
                                                }
                                              />
                                            </div>
                                            <div className="input-group-addon">
                                              ~
                                            </div>
                                            <div className="form-control-wrap">
                                              <div className="form-icon form-icon-left">
                                                <em className="icon ni ni-calendar" />
                                              </div>
                                              <input
                                                className="form-control date-picker"
                                                data-date-format="yyyy-mm-dd"
                                                id="edate"
                                                type="text"
                                                value={endDate}
                                                onChange={(e) =>
                                                  setEndDate(e.target.value)
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-10 col-md-5 col-xl-5 col-xxl-4">
                                      <div className="form-group">
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Yesterday"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Yesterday"
                                            onClick={() =>
                                              handleDateRange("yesterday")
                                            }
                                          >
                                            어제
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Today"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Today"
                                            onClick={() =>
                                              handleDateRange("today")
                                            }
                                          >
                                            오늘
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <input
                                            className="custom-control-input"
                                            id="alt-Week"
                                            name="fv-sex"
                                            type="radio"
                                          />
                                          <label
                                            className="custom-control-label"
                                            htmlFor="alt-Week"
                                            onClick={() =>
                                              handleDateRange("month")
                                            }
                                          >
                                            일주일
                                          </label>
                                        </div>
                                        <div className="custom-control custom-radio custom-control-pro no-control">
                                          <div className="col-12 col-md-20 offset-md-6">
                                            <div className="form-group withcontrol">
                                              <div className="form-control-wrap">
                                                <select
                                                  className="form-select"
                                                  value={selectedYear}
                                                  onChange={onYearChange}
                                                  onClick={onYearChange}
                                                >
                                                  {[...Array(2)].map((_, i) => {
                                                    const y = (
                                                      currentYear - i
                                                    ).toString();
                                                    return (
                                                      <option key={y} value={y}>
                                                        {y}년
                                                      </option>
                                                    );
                                                  })}
                                                </select>
                                              </div>

                                              <div className="form-control-wrap">
                                                <select
                                                  className="form-select"
                                                  value={selectedMonth}
                                                  onChange={onMonthChange}
                                                  onClick={onMonthChange}
                                                >
                                                  {[...Array(12)].map(
                                                    (_, i) => {
                                                      const m = (i + 1)
                                                        .toString()
                                                        .padStart(2, "0");
                                                      return (
                                                        <option
                                                          key={m}
                                                          value={m}
                                                        >
                                                          {m}월
                                                        </option>
                                                      );
                                                    }
                                                  )}
                                                </select>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-2 col-sm-2 col-xl-2 col-xxl-1">
                                      <div className="input-group withcontrol">
                                        <button
                                          className="btn btn-outline-primary btn-dim"
                                          type="submit"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            fetchTotalTransaction();
                                          }}
                                        >
                                          <em className="icon ni ni-search me-1" />
                                          <font>검색</font>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div
                                  className="table-responsive"
                                  data-add-focus-btn="true"
                                  data-fixed-nav-bar="true"
                                  data-pattern="priority-columns"
                                  data-sortable="true"
                                >
                                  <table
                                    cellSpacing="0"
                                    className="table dataTable no-footer dtr-inline navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          data-pos-x="0"
                                          id="id6ab644ee1c6e78-col-0"
                                        >
                                          <span className="sub-text text-center">
                                            게임사
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="1"
                                          id="id6ab644ee1c6e78-col-1"
                                        >
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="2"
                                          id="id6ab644ee1c6e78-col-2"
                                        >
                                          <span className="sub-text text-center">
                                            베팅
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="3"
                                          id="id6ab644ee1c6e78-col-3"
                                        >
                                          <span className="sub-text text-center">
                                            승
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="4"
                                          id="id6ab644ee1c6e78-col-4"
                                        >
                                          <span className="sub-text text-center">
                                            무
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="5"
                                          id="id6ab644ee1c6e78-col-5"
                                        >
                                          <span className="sub-text text-center">
                                            취소
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="6"
                                          id="id6ab644ee1c6e78-col-6"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="베팅 - (승 + 무 + 취소)"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            Win/Lose{" "}
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="7"
                                          id="id6ab644ee1c6e78-col-7"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="승 + 무 + 취소 / 베팅 * 100"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            RTP
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="8"
                                          id="id6ab644ee1c6e78-col-8"
                                        >
                                          <span className="sub-text text-center">
                                            초과 당첨금
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="9"
                                          id="id6ab644ee1c6e78-col-9"
                                        >
                                          <span className="sub-text text-center">
                                            베팅수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {vendors &&
                                        vendors
                                          .filter((v) => v.v_type === "casino")
                                          .map((v, index) => (
                                            <tr className="casino" key={index}>
                                              <td
                                                className="text-start"
                                                data-columns="id6ab644ee1c6e78-col-0"
                                                data-pos-x="0"
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <span className="badge rounded-pill badge-dim bg-outline-primary">
                                                  CASINO
                                                </span>
                                                <a href="#">{v.v_name_kor}</a>
                                              </td>
                                              <td
                                                className="text-center"
                                                data-columns="id6ab644ee1c6e78-col-1"
                                                data-pos-x="1"
                                              >
                                                KRW
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-2"
                                                data-pos-x="2"
                                              >
                                                {GetAdjustment(v,totalLogs).bet}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-3"
                                                data-pos-x="3"
                                              >
                                                {GetAdjustment(v,totalLogs).win}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-4"
                                                data-pos-x="4"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).tie}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-5"
                                                data-pos-x="5"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).cancle}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-6"
                                                data-pos-x="6"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).wl}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-7"
                                                data-pos-x="7"
                                              >
                                                {GetAdjustment(v,totalLogs).rtp}%
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-8"
                                                data-pos-x="8"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).overamount}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-9"
                                                data-pos-x="9"
                                              >
                                                {GetAdjustment(v,totalLogs).betCount}
                                              </td>
                                            </tr>
                                          ))}
                                      <tr
                                        className="casino total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          카지노 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "casino"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "casino"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>

                                      {vendors &&
                                        vendors
                                          .filter((v) => v.v_type === "slot")
                                          .map((v, index) => (
                                            <tr className="slot" key={index}>
                                              <td
                                                className="text-start"
                                                data-columns="id6ab644ee1c6e78-col-0"
                                                data-pos-x="0"
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                  SLOT
                                                </span>
                                                <a href="#">{v.v_name_kor}</a>
                                              </td>
                                              <td
                                                className="text-center"
                                                data-columns="id6ab644ee1c6e78-col-1"
                                                data-pos-x="1"
                                              >
                                                KRW
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-2"
                                                data-pos-x="2"
                                              >
                                                {GetAdjustment(v,totalLogs).bet}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-3"
                                                data-pos-x="3"
                                              >
                                                {GetAdjustment(v,totalLogs).win}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-4"
                                                data-pos-x="4"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).tie}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-5"
                                                data-pos-x="5"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).cancle}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-6"
                                                data-pos-x="6"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).wl}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-7"
                                                data-pos-x="7"
                                              >
                                                {GetAdjustment(v,totalLogs).rtp}%
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-8"
                                                data-pos-x="8"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).overamount}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-9"
                                                data-pos-x="9"
                                              >
                                                {GetAdjustment(v,totalLogs).betCount}
                                              </td>
                                            </tr>
                                          ))}
                                      <tr
                                        className="slot total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          슬롯게임 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "slot"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "slot"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          총합
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "all"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "all"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane" id="tabintab03">
                        <div className="nk-block">
                          <div className="card">
                            <div className="card-inner-group">
                              <div className="card-inner p-3 p-0">
                                <div className="nk-block nk-block-lg">
                                  <div className="row tbSearch">
                                    <div className="col-12 col-sm-12 col-xl-5" />
                                    <div className="col-12 col-md-6 offset-md-6">
                                      <div className="form-group withcontrol">
                                        <div className="form-control-wrap">
                                          <select className="form-select">
                                            <option checked value="2025">
                                              2025년
                                            </option>
                                            <option checked value="2024">
                                              2024년
                                            </option>
                                            <option checked value="2023">
                                              2023년
                                            </option>
                                          </select>
                                        </div>
                                        <div className="form-control-wrap">
                                          <select className="form-select">
                                            <option checked value="01">
                                              01월
                                            </option>
                                            <option checked value="02">
                                              02월
                                            </option>
                                            <option checked value="03">
                                              03월
                                            </option>
                                            <option checked value="04">
                                              04월
                                            </option>
                                            <option checked value="05">
                                              05월
                                            </option>
                                            <option checked value="06">
                                              06월
                                            </option>
                                            <option checked value="07">
                                              07월
                                            </option>
                                            <option checked value="08">
                                              08월
                                            </option>
                                            <option checked value="09">
                                              09월
                                            </option>
                                            <option checked value="10">
                                              10월
                                            </option>
                                            <option checked value="11">
                                              11월
                                            </option>
                                            <option checked value="12">
                                              12월
                                            </option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="nk-files-group user-days">
                              <div
                                className="table-wrapper"
                                style={{
                                  borderTop: "1px dotted #BBB",
                                  paddingTop: "5px 0",
                                }}
                              >
                                <div
                                  className="table-responsive"
                                  data-add-focus-btn="true"
                                  data-fixed-nav-bar="true"
                                  data-pattern="priority-columns"
                                  data-sortable="true"
                                >
                                  <table
                                    cellSpacing="0"
                                    className="table dataTable no-footer dtr-inline navbar-fixed-top"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          data-pos-x="0"
                                          id="id6ab644ee1c6e78-col-0"
                                        >
                                          <span className="sub-text text-center">
                                            게임사
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="1"
                                          id="id6ab644ee1c6e78-col-1"
                                        >
                                          <span className="sub-text text-center">
                                            화폐
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="2"
                                          id="id6ab644ee1c6e78-col-2"
                                        >
                                          <span className="sub-text text-center">
                                            베팅
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="3"
                                          id="id6ab644ee1c6e78-col-3"
                                        >
                                          <span className="sub-text text-center">
                                            승
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="4"
                                          id="id6ab644ee1c6e78-col-4"
                                        >
                                          <span className="sub-text text-center">
                                            무
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="5"
                                          id="id6ab644ee1c6e78-col-5"
                                        >
                                          <span className="sub-text text-center">
                                            취소
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="6"
                                          id="id6ab644ee1c6e78-col-6"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="베팅 - (승 + 무 + 취소)"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            Win/Lose{" "}
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="7"
                                          id="id6ab644ee1c6e78-col-7"
                                        >
                                          <span
                                            className="sub-text text-center"
                                            data-bs-original-title="승 + 무 + 취소 / 베팅 * 100"
                                            data-bs-toggle="tooltip"
                                          >
                                            {" "}
                                            RTP
                                            <em className="icon ni ni-info-fill vam" />
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="8"
                                          id="id6ab644ee1c6e78-col-8"
                                        >
                                          <span className="sub-text text-center">
                                            초과 당첨금
                                          </span>
                                        </th>
                                        <th
                                          data-pos-x="9"
                                          id="id6ab644ee1c6e78-col-9"
                                        >
                                          <span className="sub-text text-center">
                                            베팅수
                                          </span>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {vendors &&
                                        vendors
                                          .filter((v) => v.v_type === "casino")
                                          .map((v, index) => (
                                            <tr className="casino" key={index}>
                                              <td
                                                className="text-start"
                                                data-columns="id6ab644ee1c6e78-col-0"
                                                data-pos-x="0"
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <span className="badge rounded-pill badge-dim bg-outline-primary">
                                                  CASINO
                                                </span>
                                                <a href="#">{v.v_name_kor}</a>
                                              </td>
                                              <td
                                                className="text-center"
                                                data-columns="id6ab644ee1c6e78-col-1"
                                                data-pos-x="1"
                                              >
                                                KRW
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-2"
                                                data-pos-x="2"
                                              >
                                                {GetAdjustment(v,totalLogs).bet}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-3"
                                                data-pos-x="3"
                                              >
                                                {GetAdjustment(v,totalLogs).win}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-4"
                                                data-pos-x="4"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).tie}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-5"
                                                data-pos-x="5"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).cancle}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-6"
                                                data-pos-x="6"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).wl}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-7"
                                                data-pos-x="7"
                                              >
                                                {GetAdjustment(v,totalLogs).rtp}%
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-8"
                                                data-pos-x="8"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).overamount}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-9"
                                                data-pos-x="9"
                                              >
                                                {GetAdjustment(v,totalLogs).betCount}
                                              </td>
                                            </tr>
                                          ))}
                                      <tr
                                        className="casino total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          카지노 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "casino"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "casino"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "casino"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>

                                      {vendors &&
                                        vendors
                                          .filter((v) => v.v_type === "slot")
                                          .map((v, index) => (
                                            <tr className="slot" key={index}>
                                              <td
                                                className="text-start"
                                                data-columns="id6ab644ee1c6e78-col-0"
                                                data-pos-x="0"
                                                style={{
                                                  cursor: "pointer",
                                                }}
                                              >
                                                <span className="badge rounded-pill badge-dim bg-outline-danger me-1">
                                                  SLOT
                                                </span>
                                                <a href="#">{v.v_name_kor}</a>
                                              </td>
                                              <td
                                                className="text-center"
                                                data-columns="id6ab644ee1c6e78-col-1"
                                                data-pos-x="1"
                                              >
                                                KRW
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-2"
                                                data-pos-x="2"
                                              >
                                                {GetAdjustment(v,totalLogs).bet}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-3"
                                                data-pos-x="3"
                                              >
                                                {GetAdjustment(v,totalLogs).win}
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-4"
                                                data-pos-x="4"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).tie}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-5"
                                                data-pos-x="5"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).cancle}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-6"
                                                data-pos-x="6"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).wl}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-7"
                                                data-pos-x="7"
                                              >
                                                {GetAdjustment(v,totalLogs).rtp}%
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-8"
                                                data-pos-x="8"
                                              >
                                                <span>
                                                  {GetAdjustment(v,totalLogs).overamount}
                                                </span>
                                              </td>
                                              <td
                                                className="text-end"
                                                data-columns="id6ab644ee1c6e78-col-9"
                                                data-pos-x="9"
                                              >
                                                {GetAdjustment(v,totalLogs).betCount}
                                              </td>
                                            </tr>
                                          ))}
                                      <tr
                                        className="slot total"
                                        data-pos-y="15"
                                      >
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          슬롯게임 합계
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "slot"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "slot"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "slot"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>
                                    </tbody>
                                    <tfoot className="dt_user_view_total">
                                      <tr>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-0"
                                          data-pos-x="0"
                                        >
                                          총합
                                        </td>
                                        <td
                                          className="text-center"
                                          data-columns="id6ab644ee1c6e78-col-1"
                                          data-pos-x="1"
                                        >
                                          KRW
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-2"
                                          data-pos-x="2"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).bet
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-3"
                                          data-pos-x="3"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).win
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-4"
                                          data-pos-x="4"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).tie
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-5"
                                          data-pos-x="5"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).cancle
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-6"
                                          data-pos-x="6"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).wl
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-7"
                                          data-pos-x="7"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "all"
                                            ).rtp
                                          }
                                          %
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-8"
                                          data-pos-x="8"
                                        >
                                          <span>
                                            {
                                              GetAdjustmentByType(
                                                vendors,
                                                totalLogs,
                                                "all"
                                              ).overamount
                                            }
                                          </span>
                                        </td>
                                        <td
                                          className="text-end"
                                          data-columns="id6ab644ee1c6e78-col-9"
                                          data-pos-x="9"
                                        >
                                          {
                                            GetAdjustmentByType(
                                              vendors,
                                              totalLogs,
                                              "all"
                                            ).betCount
                                          }
                                        </td>
                                      </tr>
                                    </tfoot>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
